import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('MATCH_VIDEOS', [], undefined, 'MATCH_VIDEO');
